import client from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

/**
 * @typedef {Object} HealthDeclaration
 */

const URL = 'health-declarations/1/';
const URL_SEND = 'health-declaration/send/';

const fetchHealthDeclaration = async () => {
  return client.get(URL);
};

const sendHealthDeclaration = async (data: any) => {
  return client.post(URL_SEND, data);
};

const actions = {
  fetchHealthDeclaration,
  sendHealthDeclaration,
};

export default actions;
